import PropTypes from "prop-types";
import { createHandleChange } from "../../../helpers/formHelpers";
import { Form } from "antd";
import InputFieldErrors from "./InputFieldErrors";
import React from "react";

export default function CustomFormItem({
  name,
  label,
  children,
  validationErrors,
  setValidationErrors,
  rules,
  ...restProps
}) {
  // Fonction handleChange qui utilise la fonction helper
  const handleChange = () => createHandleChange(setValidationErrors)(name);

  // Clonage de l'élément enfant en ajoutant onChange
  const clonedElement = React.isValidElement(children)
    ? React.cloneElement(children, {
        onFocus: handleChange,
      })
    : children;

  return (
      <Form.Item label={label} extra={<InputFieldErrors errors={validationErrors} fieldName={name} />}
        name={name}
        rules={rules} {...restProps}
      >
        {clonedElement}
      </Form.Item>
  );
}

CustomFormItem.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  rules: PropTypes.arrayOf(PropTypes.object),
  validationErrors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string))
    .isRequired,
  setValidationErrors: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  restProps: PropTypes.object,
};
